<template>
  <div class="field-checkbox">
    <input
      :id="inputId"
      class="is-checkradio is-small"
      type="checkbox"
      :checked="isSelected"
      :disabled="!editable"
      @change="toggle">
    <label :for="inputId">
      {{ label }}
      <span v-if="hint" class="has-text-grey is-size-7">{{ hint }}</span>
    </label>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {entryKey} from '@/store/modules/reportFields'

export default {

  props: {
    reportKey: {type: String, required: true},
    entry: {type: Object, required: true},
    label: {type: String, required: true},
    hint: {type: String, default: ''},
    editable: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters('reportFields', [
      'config',
      'selectedKeys'
    ]),

    inputId() {
      return `${this.reportKey}--${entryKey(this.entry)}`.replace(/[^a-zA-Z0-9-_]/g, '-')
    },

    entries() {
      return this.config[this.reportKey] || []
    },

    isSelected() {
      const selected = this.selectedKeys[this.reportKey]

      return selected ? selected.has(entryKey(this.entry)) : false
    },
  },

  methods: {
    ...mapMutations('reportFields', [
      'setReportConfig'
    ]),

    toggle() {
      const key = entryKey(this.entry)

      this.setReportConfig({
        reportKey: this.reportKey,
        entries: this.isSelected
          ? this.entries.filter(existing => entryKey(existing) !== key)
          : [...this.entries, {...this.entry}]
      })
    },
  },

}
</script>

<style scoped>
.field-checkbox {
  padding: 0.15rem 0;
}
</style>
